
import { getAppSafeTopArea } from '@/utils/utils';
import { DownFill,CheckOutline,LeftOutline } from 'antd-mobile-icons'
import React from 'react';
import { styled } from 'styled-components';




const FilterHeaderView = styled.div`
  &.header{
    position: relative;
    width: 100%;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    background-color: #0158B2;
    color: #fff;
    .content{
      display: flex;
      height: 45px;
      align-items: center;
    }
    .back{
      /* position: absolute;
      left: 10px;
      top: 50%;
      transform: translate(-50%,-50%); */
      width: 80px;
      text-align: left;
      padding-left: 20px;
    }
    .text{
      flex: 1;
      text-align: center;
    }
    .right{
      width: 80px;
    }
  }

`


interface FilterHeaderProps {
  text?: React.ReactNode
  onClose?():void
}

export const FilterHeader = (props: FilterHeaderProps)=>{
  let paddingTop = getAppSafeTopArea()
  return <FilterHeaderView className='header' style={{paddingTop:paddingTop}} >
    <div className='content'>
      <div className='back'>
        <LeftOutline onClick={props?.onClose} />
      </div>
      <div className='text'>{props?.text}</div>
      <div className='right'></div>
    </div>
  </FilterHeaderView>
}